import { NonprofitNomination } from 'generated/graphql';

export const getLastOutreachDate = ({ emails }: NonprofitNomination): string | null =>
  emails?.nonprofitNominationOutreachFinal ||
  emails?.nonprofitNominationOutreachReminder ||
  emails?.nonprofitNominationOutreachInitial ||
  null;
